import { Component, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';

@Component({
  selector: 'ca-circular-loader',
  templateUrl: 'circular-loader.component.html',
  styleUrls: ['circular-loader.component.scss']
})
export class CircularLoaderComponent {
  @ContentChildren(TemplateRef) templates: QueryList<TemplateRef<any>>;
  @Input() progress;

  getProgressClass() {
    let className = '';
    for (let i = 0; i <= this.progress; i++) {
      className += ' loader-progress-' + i;
    }
    return className;
  }
}
